import 'regenerator-runtime/runtime'; // fix console error 'Uncaught ReferenceError: regeneratorRuntime is not defined'
import MicroModal from 'micromodal';
import { defaultSettings } from '@js/components/modals/settings';

const blurActiveElement = () => {
    const activeElement = document.activeElement as HTMLElement | null;
    if (activeElement !== null) {
        activeElement.blur();
    }
};
const closeOpenModals = () => {
    const openModals = document.querySelectorAll('.modal.is-open');
    openModals.forEach((modal) => {
        MicroModal.close(modal.id);
    });
};

document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('bouncerFormValid', async (e) => {
        const form = e.target as HTMLFormElement | null;
        if (form === null || !form.classList.contains('js-form')) {
            return;
        }

        const method = form.method;
        const action = form.action;
        const allInputs = form.querySelectorAll('input,textarea,select');
        let messCaption;
        let messText;

        const modalid = 'modal-message';
        const modal = document.getElementById(modalid);
        if (typeof modal !== 'undefined' && modal !== null) {
            messCaption = modal.querySelector<HTMLElement>(
                '#js-modal-message-caption'
            );
            messText = modal.querySelector<HTMLElement>(
                '#js-modal-message-text'
            );
        }

        const button = form.querySelector<HTMLButtonElement>(
            'button[type="submit"]'
        );
        if (button !== null) {
            button.setAttribute('disabled', 'disabled');
        }

        const successCallback = () => {
            form.reset();
            allInputs.forEach((input) => {
                input.dispatchEvent(new Event('change'));
            });
        }

        try {
            const body = new FormData(form);
            const response = await fetch(action, {
                method,
                headers: {
                    //'X-CSRF-TOKEN': token,
                },
                body,
            });
            if (response.ok) {

                closeOpenModals();
                if (button) {
                    button.removeAttribute('disabled');
                }

                const json = await response.json();

                if (
                    typeof messCaption !== 'undefined' &&
                    messCaption != null &&
                    typeof messText !== 'undefined' &&
                    messText != null
                ) {
                    messCaption.innerText = json.title;
                    messText.innerText = json.text;
                }

                if (json.status) {
                    blurActiveElement();
                    successCallback();
                }

                MicroModal.show(modalid, defaultSettings);

                setTimeout(() => {
                    if (modal?.classList.contains('is-open')) {
                        MicroModal.close(modalid);
                    }
                }, 5000);

                return await Promise.resolve();
            }
            throw new Error('Error form');
        } catch (err) {
            if (button) {
                button.removeAttribute('disabled');
            }
            if (
                typeof messCaption !== 'undefined' &&
                messCaption != null &&
                typeof messText !== 'undefined' &&
                messText != null
            ) {
                messCaption.innerText = 'Ошибка отправки формы';
                messText.innerText = 'Обновите страницу и попробуйте отправить форму еще раз.';
            }
            closeOpenModals();
            MicroModal.show(modalid, defaultSettings);
            setTimeout(() => {
                if (modal?.classList.contains('is-open')) {
                    MicroModal.close(modalid);
                }
            }, 10000);
            console.error(err);
        }
    });
});
